import { IAssessmentHistory, IPatientMetricsState } from 'entities/PatientMetrics/PatientMetrics.models';

export const patientMetricsReducers = {
  setAssessmentHistory: (state: IPatientMetricsState, payload: IAssessmentHistory[]) => ({ ...state, data: payload }),
  setCount: (state: IPatientMetricsState, payload: number) => ({ ...state, count: payload }),
  setLoading: (state: IPatientMetricsState, payload: boolean) => ({ ...state, loading: payload }),
};
